import { ChangeEmitter } from '@/application/ChangeEmitter';
import { ImageField } from '@/domain/image/ImageField';
import type { I2DEngine } from '@/application/ports/I2DEngine';
import type { IEntityRepository } from '@/application/ports/IEntityRepository';
import type { IPrintZoneEngine2D } from '@/application/ports/IPrintZoneEngine2D';

class ZOrderController {
    constructor(
        private readonly _engine: I2DEngine,
        private readonly _printZoneEngine: IPrintZoneEngine2D,
        private readonly _repository: IEntityRepository,
        private readonly _changeEmitter: ChangeEmitter,
    ) {}

    reorderBackward(entityId: string): void {
        this._repository.reorderBackward(entityId);
        this._enforceAlwaysOnTopDomainOrder();
        this._syncEngineZOrder();
        this._changeEmitter.emit();
    }

    reorderForward(entityId: string): void {
        this._repository.reorderForward(entityId);
        this._enforceAlwaysOnTopDomainOrder();
        this._syncEngineZOrder();
        this._changeEmitter.emit();
    }

    reorderToBack(entityId: string): void {
        this._repository.reorderToBack(entityId);
        this._enforceAlwaysOnTopDomainOrder();
        this._syncEngineZOrder();
        this._changeEmitter.emit();
    }

    reorderToFront(entityId: string): void {
        this._repository.reorderToFront(entityId);
        this._enforceAlwaysOnTopDomainOrder();
        this._syncEngineZOrder();
        this._changeEmitter.emit();
    }

    enforceOverlayZOrder(): void {
        this._engine.keepLockedBackgroundGroupToBack();
        this._engine.keepAlwaysOnTopFieldsUpFront();
        this._printZoneEngine.keepGridUpFront();
        this._printZoneEngine.keepBackgroundMaskUpFront();
    }

    private _enforceAlwaysOnTopDomainOrder(): void {
        const topFields = this._repository.getAll().filter((field) => field instanceof ImageField && field.behavior?.alwaysOnTop === true);
        topFields.forEach((field) => this._repository.reorderToFront(field.id));
    }

    private _syncEngineZOrder(): void {
        this._engine.setZOrder(this._repository.getAll().map((field) => field.id));
        this.enforceOverlayZOrder();
    }
}

export { ZOrderController };
